import { render, staticRenderFns } from "./ManualPayrun.vue?vue&type=template&id=22a1047e&scoped=true"
import script from "./ManualPayrun.vue?vue&type=script&lang=js"
export * from "./ManualPayrun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a1047e",
  null
  
)

export default component.exports